import { useMemo } from 'react';
import type { ICatalog } from '@platform/core/types';
import { useGetCatalogQuery, useMeQuery } from '@platform/state/api';
import { workspaceCatalog } from './workspaceCatalog';

/**
 * Каталог робочого простору для оболонки (меню груп, Головна, навігатор, «Усі модулі», «Налаштування»): реєстри Ради поза парламентом —
 * лише з записами (workspaceCatalog). Повертає й те, чи простір парламентський (порядок модулів груп і орієнтир «Верховна Рада»).
 */
export function useWorkspaceCatalog(ws: string): { catalog: ICatalog | undefined; parliament: boolean } {
  const { data: me } = useMeQuery();
  const { data } = useGetCatalogQuery({ workspaceId: ws }, { skip: !ws });
  const parliament = me?.workspaces.find((w) => w.id === ws)?.type === 'parliament';
  const catalog = useMemo(() => workspaceCatalog(data, parliament), [data, parliament]);
  return { catalog, parliament };
}
